import { useMutation } from '@tanstack/react-query';
import { getRevisionExercises } from '../queries';
import { practiceRevisionExercisesStore } from '../stores/practiceRevisionExercisesStore';

export function useGetPracticeRevisionExercises() {
  const { setRevisionExercises } = practiceRevisionExercisesStore()

  const { mutate, data, isPending, isError } = useMutation({
    mutationKey: ['getPracticeRevisionExercises'], 
    mutationFn: (id: string) => getRevisionExercises(id),
    onSuccess: (response) => {
      setRevisionExercises(response);
    },
    retry: false
  });

  return { mutate, data, isPending, isError };
}
